import React from 'react';
import { useMutation } from '@apollo/client';
import AddUserProductMutation from './AddUserProductMutation';

export interface AddUserProductNutritionValuesInput {
  mode: 'PER_100_UNITS' | 'PER_SERVING';
  servingSize?: number;
  calories: number;
  protein: number;
  fat: number;
  carbohydrates: number;
  fiber?: number;
}

export interface AddUserProductInput {
  name: string;
  brand?: string;
  ean?: string;
  unit: 'GRAMS' | 'MILLILITERS';
  nutritionValues: AddUserProductNutritionValuesInput;
  // Optional serving size stored as product metadata, sent only in PER_100_UNITS mode (in
  // PER_SERVING mode nutritionValues.servingSize already carries it).
  servingQuantity?: number;
}

interface IAddUserProductConnectorApolloProps {
  children: ({
    addUserProduct,
  }: {
    addUserProduct: (input: AddUserProductInput) => Promise<unknown>;
  }) => React.ReactElement;
}

const AddUserProductConnectorApollo: React.FC<IAddUserProductConnectorApolloProps> = ({
  children,
}) => {
  const [addUserProductMutation] = useMutation(AddUserProductMutation);

  const addUserProduct = async (input: AddUserProductInput) => {
    const response = await addUserProductMutation({ variables: { input } });
    return response.data?.dailyTracker?.addUserProduct;
  };

  return children({ addUserProduct });
};

export default AddUserProductConnectorApollo;
